import React, { useEffect } from 'react';
import { Outlet, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { PATHS } from '../../router/routes';
import Loader from '../custom-components/loader/Loader';
import { useUserData } from '../../context/UserDataProvider';

const ProtectedRoute = ({ isAuth, redirectPath = PATHS.SIGN_IN, children }) => {
    const router = useNavigate();
    const location = useLocation();
    const { userData, isLoading } = useUserData();

    useEffect(() => {
        if (userData) {
            const { user_info, db_subscription_information } = userData;
            const redirectUserBasedOnStatus = () => {

                if (!user_info.is_verified || !user_info.phone_number) {
                    router(PATHS.VERIFICATION);
                    return;
                }

                if (!user_info.is_agent_created) {
                    if (!location.pathname.includes(PATHS.COLLECT_COMPANY_DETAILS)) {
                        router(PATHS.COLLECT_COMPANY_DETAILS);
                    }
                    return;
                }

                if (user_info.is_agent_created) {
                    if (!location.pathname.includes(PATHS.AGENT_DEMO_PAGE)) {
                        if (location.pathname === PATHS.COLLECT_COMPANY_DETAILS) {
                            router(PATHS.AGENT_DEMO_PAGE);
                            return;
                        }
                        if (!db_subscription_information && !location.pathname.includes(PATHS.SUBSCRIPTION_PLAN)) {
                            console.log('No subscription information, redirecting to agent demo page');
                            router(PATHS.AGENT_DEMO_PAGE);
                            return;
                        }
                    }
                    const hasAccess = db_subscription_information?.has_access;
                    if (!hasAccess && location.pathname.includes(PATHS.AGENT_DEMO_PAGE)) {

                        return;
                    }
                    if (!hasAccess && !location.pathname.includes(PATHS.SUBSCRIPTION_PLAN)) {
                        router(PATHS.SUBSCRIPTION_PLAN);
                        return;
                    }

                }
            }
            redirectUserBasedOnStatus();
        }
    }, [userData, router, location]);

    if (isLoading) {
        return <Loader />;
    }

    if (!isAuth) {
        return <Navigate to={redirectPath} replace />;
    }

    return children || <Outlet />;
};

export default ProtectedRoute;
